import React from "react"
import { t } from "ttag"

import * as Styles from "./KillerQuestionSection.styles"

export const KillerQuestionSection: React.FC = () => (
  <Styles.Container>
    {t`Opening question`}
    <Styles.Paragraph>
      {t`
        The opening question is a mood question that serves as an introduction to the survey.
        It may be modified when scheduling a survey.
        When viewing the survey, the default opening question will be used.
      `}
    </Styles.Paragraph>
  </Styles.Container>
)
